import Actions from "./Actions";
import Name from "./Name";

const folderComponents = {
  Actions,
  Name
}

export default folderComponents